<template>
  <PromotionBanner @close="onBannerClose"></PromotionBanner>
  <HeaderGlobal></HeaderGlobal>
  <main><router-view></router-view></main>
  <FooterPrincipal></FooterPrincipal>
</template>

<script>
import HeaderGlobal from './components/HeaderGlobal.vue';
import FooterPrincipal from './components/FooterPrincipal.vue';
import PromotionBanner from './components/PromotionBanner.vue';

export default {
  name: 'App',
  components: {
    HeaderGlobal,
    FooterPrincipal,
    PromotionBanner
  },
  methods: {
    onBannerClose() {
      console.log('Banner promocional cerrado');
    }
  }
}
</script>

<style>
@import './assets/style.css';
</style>
